import { render, staticRenderFns } from "./Brands.vue?vue&type=template&id=22b94057&scoped=true"
import script from "./Brands.vue?vue&type=script&lang=js"
export * from "./Brands.vue?vue&type=script&lang=js"
import style0 from "./Brands.vue?vue&type=style&index=0&id=22b94057&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b94057",
  null
  
)

export default component.exports